import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";

const Footer = () => {
  const nav = useNavigate();
  return (
    <>
      <footer
        className=" py-3  footer_web flex items-center"
        style={{ "background": "#232323", "height": "20vh" }}
      >
        <div className="w-[90%] m-auto flex justify-between items-center footer_container">
          <div className="footer_left">
            {/* lorrycare logo START */}
            <Link to={"/"}>
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="100px"
                height="90px"
                viewBox="0 0 584.000000 427.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g
                  transform="translate(0.000000,427.000000) scale(0.100000,-0.100000)"
                  fill="#FFFFFF"
                  stroke="none"
                >
                  <path
                    d="M3015 4254 c-198 -30 -384 -102 -544 -208 -183 -121 -344 -296 -439
-475 -41 -76 -45 -80 -80 -83 l-37 -3 0 -65 0 -65 140 0 140 0 3 66 c3 60 1
67 -18 72 -11 3 -20 10 -20 15 0 21 103 163 171 236 248 266 627 412 979 378
314 -31 562 -150 775 -373 165 -172 270 -374 321 -619 21 -104 24 -342 5 -445
-49 -264 -166 -491 -346 -670 -174 -174 -387 -288 -630 -336 -90 -18 -368 -18
-450 0 -163 36 -327 104 -457 192 -131 88 -390 381 -361 410 4 4 53 10 108 11
l100 3 0 70 0 70 -249 3 c-193 2 -251 -1 -258 -10 -4 -7 -8 -38 -8 -69 0 -65
5 -69 80 -69 l48 0 38 -68 c194 -351 504 -582 914 -679 96 -23 418 -25 525 -4
445 88 831 404 996 817 77 193 104 334 103 549 -1 232 -45 418 -147 620 -260
519 -833 817 -1402 729z"
                  />
                  <path
                    d="M2300 3420 l0 -70 180 0 180 0 0 -60 0 -60 -225 0 -225 0 0 -75 0
-75 225 0 225 0 0 -60 0 -60 -365 0 -365 0 0 -70 0 -70 365 0 365 0 0 -60 0
-60 -130 0 -130 0 0 -70 0 -70 130 0 130 0 0 -60 0 -60 -90 0 -90 0 0 -75 0
-75 150 0 150 0 0 600 0 600 -240 0 -240 0 0 -70z"
                  />
                  <path
                    d="M2880 2890 l0 -600 94 0 c78 0 97 3 119 20 23 18 25 27 29 112 4 108
26 162 92 226 65 64 118 86 211 90 103 5 175 -21 240 -84 68 -66 99 -139 100
-242 2 -113 5 -116 147 -120 128 -4 178 7 207 45 20 24 21 39 21 280 0 200 -3
260 -14 282 -22 41 -171 86 -350 106 -76 8 -146 15 -156 15 -11 0 -43 47 -94
139 -76 135 -81 140 -138 173 -33 18 -92 54 -132 79 -95 62 -156 79 -278 79
l-98 0 0 -600z m440 415 c20 -10 49 -52 99 -140 39 -69 71 -127 71 -130 0 -3
-119 -5 -265 -5 l-265 0 0 145 0 145 165 0 c127 0 173 -3 195 -15z"
                  />
                  <path d="M1700 3155 l0 -75 190 0 190 0 0 75 0 75 -190 0 -190 0 0 -75z" />
                  <path d="M1560 2890 l0 -70 125 0 125 0 0 70 0 70 -125 0 -125 0 0 -70z" />
                  <path d="M2120 2630 l0 -70 75 0 75 0 0 70 0 70 -75 0 -75 0 0 -70z" />
                  <path
                    d="M3321 2644 c-90 -45 -151 -162 -136 -257 23 -134 125 -223 255 -221
144 1 252 109 252 254 0 69 -22 123 -70 174 -52 54 -103 76 -183 76 -51 0 -77
-6 -118 -26z m205 -138 c30 -30 34 -41 34 -84 0 -115 -129 -171 -209 -91 -80
80 -24 209 91 209 43 0 54 -4 84 -34z"
                  />
                  <path
                    d="M678 727 c-91 -26 -185 -107 -227 -197 -36 -77 -42 -211 -13 -288 98
-256 425 -323 612 -126 78 83 95 128 95 254 0 89 -4 113 -24 157 -29 64 -122
155 -188 184 -61 27 -189 34 -255 16z m210 -146 c82 -42 122 -113 122 -213 -1
-138 -90 -228 -225 -228 -136 0 -228 93 -228 230 0 96 44 169 128 213 44 23
156 22 203 -2z"
                  />
                  <path
                    d="M3583 722 c-98 -35 -162 -91 -210 -186 -38 -73 -44 -216 -14 -298 60
-157 205 -248 374 -235 82 7 167 43 220 95 64 62 64 65 -2 105 l-59 35 -20
-28 c-31 -42 -98 -70 -165 -70 -69 0 -120 20 -165 63 -47 44 -64 91 -65 169 0
86 30 150 92 193 37 26 53 30 120 33 88 4 141 -15 181 -65 l21 -27 52 28 c29
16 56 32 61 36 15 14 -76 101 -139 132 -79 40 -201 49 -282 20z"
                  />
                  <path
                    d="M0 375 l0 -355 205 0 205 0 0 65 0 65 -135 0 -135 0 0 290 0 290 -70
0 -70 0 0 -355z"
                  />
                  <path
                    d="M1250 375 l0 -355 70 0 70 0 0 120 0 121 57 -3 56 -3 70 -117 69
-118 75 0 75 0 -20 33 c-101 168 -134 231 -123 235 28 9 85 69 102 107 26 56
25 149 -2 200 -11 22 -36 55 -56 73 -56 50 -113 62 -290 62 l-153 0 0 -355z
m325 211 c18 -8 39 -25 46 -37 17 -33 15 -91 -5 -122 -23 -34 -64 -47 -152
-47 l-74 0 0 110 0 110 75 0 c43 0 90 -6 110 -14z"
                  />
                  <path
                    d="M1880 376 l0 -356 70 0 70 0 0 120 0 120 53 0 53 0 69 -120 70 -120
73 0 c39 0 72 2 72 6 0 3 -31 58 -70 123 -38 65 -70 121 -70 124 0 3 24 30 53
59 95 96 103 211 19 308 -64 75 -93 84 -289 88 l-173 4 0 -356z m331 201 c65
-43 62 -137 -5 -178 -23 -14 -50 -19 -108 -19 l-78 0 0 110 0 110 79 0 c65 0
84 -4 112 -23z"
                  />
                  <path
                    d="M2436 698 c9 -18 63 -115 120 -216 l104 -185 0 -138 0 -139 70 0 70
0 0 136 0 136 120 213 c66 117 120 216 120 220 0 3 -34 5 -76 3 l-77 -3 -75
-142 c-41 -79 -78 -143 -81 -143 -3 0 -40 66 -81 145 l-75 145 -78 0 -78 0 17
-32z"
                  />
                  <path
                    d="M4272 703 c-5 -15 -28 -80 -50 -143 -111 -315 -182 -522 -182 -530 0
-6 33 -10 73 -10 l74 0 18 60 18 60 148 0 148 0 22 -60 22 -60 68 0 c38 0 69
3 68 8 0 4 -55 162 -122 352 l-123 345 -86 3 -86 3 -10 -28z m152 -291 c25
-73 46 -135 46 -138 0 -2 -45 -4 -101 -4 -77 0 -100 3 -97 13 3 6 25 71 49
144 24 72 47 128 50 125 4 -4 27 -67 53 -140z"
                  />
                  <path
                    d="M4780 376 l0 -356 65 0 65 0 0 120 0 120 58 0 57 -1 68 -119 69 -120
74 0 c72 0 74 1 64 20 -6 11 -40 71 -76 132 -41 70 -61 114 -54 116 7 3 28 18
47 35 119 105 98 290 -44 374 -47 27 -52 28 -220 31 l-173 4 0 -356z m327 204
c70 -42 63 -154 -11 -185 -21 -9 -67 -15 -111 -15 l-75 0 0 110 0 110 83 0
c64 0 89 -4 114 -20z"
                  />
                  <path
                    d="M5400 375 l0 -355 220 0 220 0 0 65 0 65 -150 0 -150 0 0 80 0 80
135 0 135 0 0 65 0 65 -135 0 -135 0 0 75 0 75 145 0 145 0 0 70 0 70 -215 0
-215 0 0 -355z"
                  />
                </g>
              </svg>
            </Link>
            {/* lorrycare logo END */}
          </div>

          {/* info links */}
          <ul className="info__links  w-[90%] m-auto py-5">
            <div className="flex justify-center items-center flex-wrap">
              <li style={{ "color": "rgba(255, 255, 255, 0.5)" }}>
                <span
                  className="f_link cursor-pointer"
                  onClick={() => {
                    nav("/about-us");
                    window.scrollTo(0, 0);
                  }}
                >
                  About us
                </span>
              </li>
              <li
                style={{ "color": "rgba(255, 255, 255, 0.5)" }}
                className={"ml-4"}
              >
                <span
                  className="cursor-pointer f_link"
                  onClick={() => {
                    nav("/refund-policy");
                    window.scrollTo(0, 0);
                  }}
                >
                  Refund Policy
                </span>
              </li>
              <li
                style={{ "color": "rgba(255, 255, 255, 0.5)" }}
                className={"ml-4"}
              >
                <span
                  className="f_link cursor-pointer"
                  onClick={() => {
                    nav("/faqs");
                    window.scrollTo(0, 0);
                  }}
                >
                  FAQs
                </span>
              </li>
              <li
                style={{ "color": "rgba(255, 255, 255, 0.5)" }}
                className={"ml-4"}
              >
                <span
                  className="f_link cursor-pointer"
                  onClick={() => {
                    nav("/blog");
                    window.scrollTo(0, 0);
                  }}
                >
                  Blog
                </span>
              </li>
              <li
                style={{ "color": "rgba(255, 255, 255, 0.5)" }}
                className={"ml-4"}
              >
                <span
                  className="f_link cursor-pointer"
                  onClick={() => {
                    nav("/terms-and-conditions");
                    window.scrollTo(0, 0);
                  }}
                >
                  Terms of Service
                </span>
              </li>
              <li
                style={{ "color": "rgba(255, 255, 255, 0.5)" }}
                className={"ml-4"}
              >
                <span
                  className="f_link cursor-pointer"
                  onClick={() => {
                    nav("/private-policy");
                    window.scrollTo(0, 0);
                  }}
                >
                  Privacy Policy
                </span>
              </li>
              <li
                style={{ "color": "rgba(255, 255, 255, 0.5)" }}
                className={"ml-4"}
              >
                <span
                  className="f_link cursor-pointer"
                  onClick={() => {
                    nav("/contact-us");
                    window.scrollTo(0, 0);
                  }}
                >
                  Contact Us
                </span>
              </li>
            </div>
            <div className="flex justify-center items-center mt-6">
              <p className="text-md text-white underline font-Cardo mr-2">
                Powered by
              </p>
              <img src="./ulip.png" alt="" style={{ "width": "4rem" }} />
            </div>
          </ul>

          <div className="footer_right">
            <Link
              to={
                "https://play.google.com/store/apps/details?id=com.lorrycare.app&pcampaignid=web_share"
              }
            >
              <Tooltip title="Download our app" placement="top">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10rem"
                  viewBox="0 0 135 40"
                  id="google"
                >
                  <path d="M130 40H5c-2.8 0-5-2.2-5-5V5c0-2.8 2.2-5 5-5h125c2.8 0 5 2.2 5 5v30c0 2.8-2.2 5-5 5z" />
                  <path
                    fill="#a6a6a6"
                    d="M130 .8c2.3 0 4.2 1.9 4.2 4.2v30c0 2.3-1.9 4.2-4.2 4.2H5C2.7 39.2.8 37.3.8 35V5C.8 2.7 2.7.8 5 .8h125m0-.8H5C2.2 0 0 2.3 0 5v30c0 2.8 2.2 5 5 5h125c2.8 0 5-2.2 5-5V5c0-2.7-2.2-5-5-5z"
                  />
                  <path
                    fill="#fff"
                    stroke="#fff"
                    strokeMiterlimit="10"
                    strokeWidth=".2"
                    d="M47.4 10.2c0 .8-.2 1.5-.7 2-.6.6-1.3.9-2.2.9-.9 0-1.6-.3-2.2-.9-.6-.6-.9-1.3-.9-2.2 0-.9.3-1.6.9-2.2.6-.6 1.3-.9 2.2-.9.4 0 .8.1 1.2.3.4.2.7.4.9.7l-.5.5c-.4-.5-.9-.7-1.6-.7-.6 0-1.2.2-1.6.7-.5.4-.7 1-.7 1.7s.2 1.3.7 1.7c.5.4 1 .7 1.6.7.7 0 1.2-.2 1.7-.7.3-.3.5-.7.5-1.2h-2.2v-.8h2.9v.4zM52 7.7h-2.7v1.9h2.5v.7h-2.5v1.9H52v.8h-3.5V7H52v.7zM55.3 13h-.8V7.7h-1.7V7H57v.7h-1.7V13zM59.9 13V7h.8v6h-.8zM64.1 13h-.8V7.7h-1.7V7h4.1v.7H64V13zM73.6 12.2c-.6.6-1.3.9-2.2.9-.9 0-1.6-.3-2.2-.9-.6-.6-.9-1.3-.9-2.2s.3-1.6.9-2.2c.6-.6 1.3-.9 2.2-.9.9 0 1.6.3 2.2.9.6.6.9 1.3.9 2.2 0 .9-.3 1.6-.9 2.2zm-3.8-.5c.4.4 1 .7 1.6.7.6 0 1.2-.2 1.6-.7.4-.4.7-1 .7-1.7s-.2-1.3-.7-1.7c-.4-.4-1-.7-1.6-.7-.6 0-1.2.2-1.6.7-.4.4-.7 1-.7 1.7s.2 1.3.7 1.7zM75.6 13V7h.9l2.9 4.7V7h.8v6h-.8l-3.1-4.9V13h-.7z"
                  />
                  <path
                    fill="#fff"
                    d="M68.1 21.8c-2.4 0-4.3 1.8-4.3 4.3 0 2.4 1.9 4.3 4.3 4.3s4.3-1.8 4.3-4.3c0-2.6-1.9-4.3-4.3-4.3zm0 6.8c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6c1.3 0 2.4 1 2.4 2.6 0 1.5-1.1 2.6-2.4 2.6zm-9.3-6.8c-2.4 0-4.3 1.8-4.3 4.3 0 2.4 1.9 4.3 4.3 4.3s4.3-1.8 4.3-4.3c0-2.6-1.9-4.3-4.3-4.3zm0 6.8c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6c1.3 0 2.4 1 2.4 2.6 0 1.5-1.1 2.6-2.4 2.6zm-11.1-5.5v1.8H52c-.1 1-.5 1.8-1 2.3-.6.6-1.6 1.3-3.3 1.3-2.7 0-4.7-2.1-4.7-4.8s2.1-4.8 4.7-4.8c1.4 0 2.5.6 3.3 1.3l1.3-1.3c-1.1-1-2.5-1.8-4.5-1.8-3.6 0-6.7 3-6.7 6.6 0 3.6 3.1 6.6 6.7 6.6 2 0 3.4-.6 4.6-1.9 1.2-1.2 1.6-2.9 1.6-4.2 0-.4 0-.8-.1-1.1h-6.2zm45.4 1.4c-.4-1-1.4-2.7-3.6-2.7s-4 1.7-4 4.3c0 2.4 1.8 4.3 4.2 4.3 1.9 0 3.1-1.2 3.5-1.9l-1.4-1c-.5.7-1.1 1.2-2.1 1.2s-1.6-.4-2.1-1.3l5.7-2.4-.2-.5zm-5.8 1.4c0-1.6 1.3-2.5 2.2-2.5.7 0 1.4.4 1.6.9l-3.8 1.6zM82.6 30h1.9V17.5h-1.9V30zm-3-7.3c-.5-.5-1.3-1-2.3-1-2.1 0-4.1 1.9-4.1 4.3s1.9 4.2 4.1 4.2c1 0 1.8-.5 2.2-1h.1v.6c0 1.6-.9 2.5-2.3 2.5-1.1 0-1.9-.8-2.1-1.5l-1.6.7c.5 1.1 1.7 2.5 3.8 2.5 2.2 0 4-1.3 4-4.4V22h-1.8v.7zm-2.2 5.9c-1.3 0-2.4-1.1-2.4-2.6s1.1-2.6 2.4-2.6c1.3 0 2.3 1.1 2.3 2.6s-1 2.6-2.3 2.6zm24.4-11.1h-4.5V30h1.9v-4.7h2.6c2.1 0 4.1-1.5 4.1-3.9s-2-3.9-4.1-3.9zm.1 6h-2.7v-4.3h2.7c1.4 0 2.2 1.2 2.2 2.1-.1 1.1-.9 2.2-2.2 2.2zm11.5-1.8c-1.4 0-2.8.6-3.3 1.9l1.7.7c.4-.7 1-.9 1.7-.9 1 0 1.9.6 2 1.6v.1c-.3-.2-1.1-.5-1.9-.5-1.8 0-3.6 1-3.6 2.8 0 1.7 1.5 2.8 3.1 2.8 1.3 0 1.9-.6 2.4-1.2h.1v1h1.8v-4.8c-.2-2.2-1.9-3.5-4-3.5zm-.2 6.9c-.6 0-1.5-.3-1.5-1.1 0-1 1.1-1.3 2-1.3.8 0 1.2.2 1.7.4-.2 1.2-1.2 2-2.2 2zm10.5-6.6l-2.1 5.4h-.1l-2.2-5.4h-2l3.3 7.6-1.9 4.2h1.9l5.1-11.8h-2zm-16.8 8h1.9V17.5h-1.9V30z"
                  />
                  <linearGradient
                    id="a"
                    x1="21.8"
                    x2="5.017"
                    y1="33.29"
                    y2="16.508"
                    gradientTransform="matrix(1 0 0 -1 0 42)"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0" stopColor="#00a0ff" />
                    <stop offset=".007" stopColor="#00a1ff" />
                    <stop offset=".26" stopColor="#00beff" />
                    <stop offset=".512" stopColor="#00d2ff" />
                    <stop offset=".76" stopColor="#00dfff" />
                    <stop offset="1" stopColor="#00e3ff" />
                  </linearGradient>
                  <path
                    fill="url(#a)"
                    d="M10.4 7.5c-.3.3-.4.8-.4 1.4V31c0 .6.2 1.1.5 1.4l.1.1L23 20.1v-.2L10.4 7.5z"
                  />
                  <linearGradient
                    id="b"
                    x1="33.834"
                    x2="9.637"
                    y1="21.999"
                    y2="21.999"
                    gradientTransform="matrix(1 0 0 -1 0 42)"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0" stopColor="#ffe000" />
                    <stop offset=".409" stopColor="#ffbd00" />
                    <stop offset=".775" stopColor="orange" />
                    <stop offset="1" stopColor="#ff9c00" />
                  </linearGradient>
                  <path
                    fill="url(#b)"
                    d="M27 24.3l-4.1-4.1V19.9l4.1-4.1.1.1 4.9 2.8c1.4.8 1.4 2.1 0 2.9l-5 2.7z"
                  />
                  <linearGradient
                    id="c"
                    x1="24.827"
                    x2="2.069"
                    y1="19.704"
                    y2="-3.054"
                    gradientTransform="matrix(1 0 0 -1 0 42)"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0" stopColor="#ff3a44" />
                    <stop offset="1" stopColor="#c31162" />
                  </linearGradient>
                  <path
                    fill="url(#c)"
                    d="M27.1 24.2L22.9 20 10.4 32.5c.5.5 1.2.5 2.1.1l14.6-8.4"
                  />
                  <linearGradient
                    id="d"
                    x1="7.297"
                    x2="17.46"
                    y1="41.824"
                    y2="31.661"
                    gradientTransform="matrix(1 0 0 -1 0 42)"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0" stopColor="#32a071" />
                    <stop offset=".069" stopColor="#2da771" />
                    <stop offset=".476" stopColor="#15cf74" />
                    <stop offset=".801" stopColor="#06e775" />
                    <stop offset="1" stopColor="#00f076" />
                  </linearGradient>
                  <path
                    fill="url(#d)"
                    d="M27.1 15.8L12.5 7.5c-.9-.5-1.6-.4-2.1.1L22.9 20l4.2-4.2z"
                  />
                  <path
                    d="M27 24.1l-14.5 8.2c-.8.5-1.5.4-2 0l-.1.1.1.1c.5.4 1.2.5 2 0L27 24.1z"
                    enableBackground="new"
                    opacity=".2"
                  />
                  <path
                    d="M10.4 32.3c-.3-.3-.4-.8-.4-1.4v.1c0 .6.2 1.1.5 1.4v-.1h-.1zM32 21.3l-5 2.8.1.1 4.9-2.8c.7-.4 1-.9 1-1.4 0 .5-.4.9-1 1.3z"
                    enableBackground="new"
                    opacity=".12"
                  />
                  <path
                    fill="#fff"
                    d="M12.5 7.6L32 18.7c.6.4 1 .8 1 1.3 0-.5-.3-1-1-1.4L12.5 7.5c-1.4-.8-2.5-.2-2.5 1.4V9c0-1.5 1.1-2.2 2.5-1.4z"
                    enableBackground="new"
                    opacity=".25"
                  />
                </svg>
              </Tooltip>
            </Link>

            <div className="social_media_wrapperF flex justify-between items-center mt-5">
              {/* instagram */}
              <Tooltip title="Instagram" placement="bottom">
                <div className="cursor-pointer">
                  <a
                    href="https://www.instagram.com/lorry_care_/"
                    target={"_black"}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 109 109"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M72.8183 54.4837C72.8183 53.01 72.6016 51.4063 72.1682 49.6725H77.6296V75.9391C77.6296 76.6326 77.3912 77.1961 76.9144 77.6296C76.4376 78.063 75.8524 78.2797 75.1589 78.2797H32.3782C31.6846 78.2797 31.1212 78.063 30.6877 77.6296C30.2543 77.1961 30.0376 76.6326 30.0376 75.9391V49.6725H35.3689C34.9355 51.4063 34.7187 53.01 34.7187 54.4837C34.7187 57.0844 35.2172 59.555 36.2141 61.8956C37.211 64.2362 38.5764 66.2517 40.3102 67.9421C42.0439 69.6325 44.0811 70.9762 46.4217 71.9731C48.7623 72.9701 51.2329 73.4685 53.8336 73.4685C56.4342 73.4685 58.9048 72.9701 61.2454 71.9731C63.586 70.9762 65.6015 69.6325 67.292 67.9421C68.9824 66.2517 70.3261 64.2362 71.323 61.8956C72.3199 59.555 72.8183 57.0844 72.8183 54.4837ZM53.8336 66.3167C52.1865 66.3167 50.6261 66.0133 49.1524 65.4065C47.6787 64.7997 46.4 63.9544 45.3164 62.8708C44.2328 61.7872 43.3876 60.5303 42.7808 59.0999C42.174 57.6695 41.8705 56.1308 41.8705 54.4837C41.8705 52.8366 42.174 51.2763 42.7808 49.8025C43.3876 48.3288 44.2328 47.0502 45.3164 45.9666C46.4 44.883 47.6787 44.0378 49.1524 43.4309C50.6261 42.8241 52.1865 42.5207 53.8336 42.5207C55.4806 42.5207 57.0194 42.8241 58.4497 43.4309C59.8801 44.0378 61.1371 44.883 62.2207 45.9666C63.3043 47.0502 64.1495 48.3288 64.7563 49.8025C65.3631 51.2763 65.6665 52.8366 65.6665 54.4837C65.6665 56.1308 65.3631 57.6695 64.7563 59.0999C64.1495 60.5303 63.3043 61.7872 62.2207 62.8708C61.1371 63.9544 59.8801 64.7997 58.4497 65.4065C57.0194 66.0133 55.4806 66.3167 53.8336 66.3167ZM75.1589 30.6877C75.8524 30.6877 76.4376 30.9045 76.9144 31.3379C77.3912 31.7713 77.6296 32.3348 77.6296 33.0283V40.1801C77.6296 40.8736 77.3912 41.4371 76.9144 41.8705C76.4376 42.304 75.8524 42.5207 75.1589 42.5207H68.0071C67.3136 42.5207 66.7502 42.304 66.3167 41.8705C65.8833 41.4371 65.6665 40.8736 65.6665 40.1801V33.0283C65.6665 32.3348 65.8833 31.7713 66.3167 31.3379C66.7502 30.9045 67.3136 30.6877 68.0071 30.6877H75.1589ZM81.5305 0C85.2581 0 88.7907 0.71518 92.1282 2.14554C95.4657 3.5759 98.3698 5.52639 100.84 7.99701C103.311 10.4676 105.262 13.35 106.692 16.6442C108.122 19.9384 108.837 23.4492 108.837 27.1768V81.5305C108.837 85.2581 108.122 88.7907 106.692 92.1282C105.262 95.4657 103.311 98.3698 100.84 100.84C98.3698 103.311 95.4657 105.262 92.1282 106.692C88.7907 108.122 85.2581 108.837 81.5305 108.837H27.1768C23.4492 108.837 19.9384 108.122 16.6442 106.692C13.35 105.262 10.4676 103.311 7.99701 100.84C5.52639 98.3698 3.5759 95.4657 2.14554 92.1282C0.71518 88.7907 0 85.2581 0 81.5305V27.1768C0 23.4492 0.71518 19.9384 2.14554 16.6442C3.5759 13.35 5.52639 10.4676 7.99701 7.99701C10.4676 5.52639 13.35 3.5759 16.6442 2.14554C19.9384 0.71518 23.4492 0 27.1768 0H81.5305ZM84.7814 30.6877C84.7814 28.6939 84.0879 27.0035 82.7008 25.6165C81.3138 24.2294 79.6234 23.5359 77.6296 23.5359H30.0376C28.0437 23.5359 26.3533 24.2294 24.9663 25.6165C23.5793 27.0035 22.8858 28.6939 22.8858 30.6877V78.2797C22.8858 80.2736 23.5793 81.964 24.9663 83.351C26.3533 84.738 28.0437 85.4315 30.0376 85.4315H77.6296C79.6234 85.4315 81.3138 84.738 82.7008 83.351C84.0879 81.964 84.7814 80.2736 84.7814 78.2797V30.6877Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                </div>
              </Tooltip>

              {/* facebook */}
              <Tooltip title="Facebook" placement="bottom">
                <div className="ml-2 cursor-pointer">
                  <a
                    href="https://www.facebook.com/profile.php?id=100091414827767"
                    target={"_black"}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 109 109"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M54.3538 0C61.8778 0 68.9477 1.42695 75.5635 4.28085C82.1794 7.13475 87.9521 11.0264 92.8815 15.9559C97.811 20.8854 101.703 26.6364 104.557 33.209C107.41 39.7817 108.837 46.8299 108.837 54.3538C108.837 61.8778 107.41 68.9477 104.557 75.5635C101.703 82.1794 97.811 87.9521 92.8815 92.8815C87.9521 97.811 82.1794 101.703 75.5635 104.557C68.9477 107.41 61.8778 108.837 54.3538 108.837C46.8299 108.837 39.7817 107.41 33.209 104.557C26.6364 101.703 20.8854 97.811 15.9559 92.8815C11.0264 87.9521 7.13475 82.1794 4.28085 75.5635C1.42695 68.9477 0 61.8778 0 54.3538C0 46.8299 1.42695 39.7817 4.28085 33.209C7.13475 26.6364 11.0264 20.8854 15.9559 15.9559C20.8854 11.0264 26.6364 7.13475 33.209 4.28085C39.7817 1.42695 46.8299 0 54.3538 0ZM74.85 23.7393H63.3047C61.0562 23.7393 58.9806 24.1284 57.078 24.9068C55.1754 25.6851 53.5107 26.7229 52.0837 28.0201C50.6567 29.3174 49.5541 30.7875 48.7758 32.4307C47.9974 34.0739 47.6083 35.717 47.6083 37.3602V44.2355H37.3602V57.7266H47.6083V84.9684H61.2292V57.7266H71.3475V44.2355H61.2292V40.733C61.2292 39.6952 61.6399 38.8736 62.4615 38.2682C63.2831 37.6628 63.9966 37.3602 64.6019 37.3602H74.85V23.7393Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                </div>
              </Tooltip>

              {/* youtube */}
              <Tooltip title="Youtube" placement="bottom">
                <div className="ml-2 cursor-pointer">
                  <a
                    href="https://www.youtube.com/channel/UCrN4zOz5tsEXfGjaxGywDUw"
                    target={"_black"}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 109 109"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M78.5398 66.4467C79.2333 66.4467 79.7101 66.6635 79.9701 67.0969C80.3169 67.4437 80.4903 68.0505 80.4903 68.9174V71.1279H76.5893V68.9174C76.5893 68.1372 76.7193 67.5303 76.9794 67.0969C77.4128 66.6635 77.933 66.4467 78.5398 66.4467ZM63.326 66.4467C63.9328 66.4467 64.3662 66.6201 64.6263 66.9669C64.973 67.3136 65.1464 67.8338 65.1464 68.5273V79.45C65.1464 80.1435 65.0164 80.6203 64.7563 80.8804C64.4963 81.2271 64.1062 81.4005 63.586 81.4005C63.2393 81.4005 62.8925 81.3138 62.5458 81.1404C62.1123 80.9671 61.7656 80.707 61.5055 80.3602V67.2269C61.8523 66.8802 62.1557 66.6635 62.4157 66.5768C62.5891 66.4901 62.8925 66.4467 63.326 66.4467ZM54.4837 0C62.0256 0 69.0907 1.43036 75.6791 4.29108C82.2674 7.1518 88.0105 11.0311 92.9084 15.929C97.8063 20.8269 101.686 26.57 104.546 33.1584C107.407 39.7467 108.837 46.8118 108.837 54.3537C108.837 61.8956 107.407 68.9607 104.546 75.549C101.686 82.1374 97.8063 87.9021 92.9084 92.8434C88.0105 97.7846 82.2674 101.686 75.6791 104.546C69.0907 107.407 62.0256 108.837 54.4837 108.837C46.9418 108.837 39.8767 107.407 33.2884 104.546C26.7001 101.686 20.9353 97.7846 15.994 92.8434C11.0528 87.9021 7.1518 82.1374 4.29108 75.549C1.43036 68.9607 0 61.8956 0 54.3537C0 46.8118 1.43036 39.7467 4.29108 33.1584C7.1518 26.57 11.0528 20.8269 15.994 15.929C20.9353 11.0311 26.7001 7.1518 33.2884 4.29108C39.8767 1.43036 46.9418 0 54.4837 0ZM39.1399 55.7841H23.796V59.9451H28.9973V84.3913H33.9386V59.9451H39.1399V55.7841ZM39.2699 42.2606L45.7715 23.796H40.0501L36.6692 36.4092H36.2791L32.6382 23.796H27.0468L33.6785 42.7808V55.2639H39.2699V42.2606ZM53.7035 63.326H49.2824V79.32C49.109 79.5801 48.8923 79.7968 48.6323 79.9701L47.8521 80.4903C47.3319 80.7503 46.9418 80.8804 46.6818 80.8804C46.2483 80.8804 45.9449 80.7937 45.7715 80.6203C45.5982 80.4469 45.5115 80.0568 45.5115 79.45V63.326H41.0904V81.0104C41.0904 82.2241 41.3504 83.1343 41.8705 83.7411C42.3907 84.4346 43.1275 84.7814 44.0811 84.7814C44.8613 84.7814 45.7282 84.5213 46.6818 84.0012C47.462 83.6544 48.3288 83.0042 49.2824 82.0507V84.3913H53.7035V63.326ZM53.3134 55.7841C55.654 55.7841 57.4311 55.2206 58.6448 54.0936C59.9451 53.0534 60.5953 51.493 60.5953 49.4124V37.4494C60.5953 35.8024 59.9451 34.372 58.6448 33.1584C57.4311 32.0314 55.7407 31.4679 53.5735 31.4679C51.3196 31.4679 49.5425 31.9881 48.2422 33.0283C46.8551 34.0686 46.1616 35.4989 46.1616 37.3194V49.4124C46.1616 51.4063 46.8118 52.9667 48.1121 54.0936C49.3258 55.2206 51.0595 55.7841 53.3134 55.7841ZM69.6976 68.3972C69.6976 66.6635 69.3075 65.3198 68.5273 64.3662C67.9204 63.4993 66.8802 63.0659 65.4065 63.0659C64.6263 63.0659 63.9328 63.2393 63.326 63.586C62.6324 63.8461 62.0256 64.3229 61.5055 65.0164V55.7841H56.9544V84.3913H61.5055V82.8309C61.7656 83.1776 62.0473 83.4594 62.3507 83.6761C62.6541 83.8928 62.9792 84.0879 63.326 84.2612C63.9328 84.5213 64.713 84.6513 65.6665 84.6513C66.9669 84.6513 67.9638 84.2612 68.6573 83.481C69.3508 82.6141 69.6976 81.4872 69.6976 80.1002V68.3972ZM68.1372 55.524C69.1774 55.524 70.131 55.3073 70.9979 54.8738C71.8648 54.4404 72.8183 53.7035 73.8586 52.6633V55.2639H78.7999V31.9881H73.8586V49.6725C73.5119 50.106 72.9917 50.5394 72.2982 50.9728C71.7781 51.2329 71.3446 51.3629 70.9979 51.3629C70.3911 51.3629 70.0443 51.2329 69.9576 50.9728C69.6976 50.7128 69.5675 50.3227 69.5675 49.8025V31.9881H64.6263V51.493C64.6263 52.88 64.9297 53.8769 65.5365 54.4837C65.97 55.1772 66.8368 55.524 68.1372 55.524ZM85.0414 69.0474C85.0414 66.9669 84.478 65.4065 83.351 64.3662C82.3107 63.326 80.7503 62.8058 78.6698 62.8058C76.676 62.8058 75.0722 63.3693 73.8586 64.4963C72.645 65.7099 72.0382 67.2269 72.0382 69.0474V78.4098C72.0382 80.4903 72.6016 82.094 73.7286 83.221C74.9422 84.4346 76.5026 85.0414 78.4098 85.0414C80.577 85.0414 82.2241 84.478 83.351 83.351C84.478 82.3107 85.0414 80.6637 85.0414 78.4098V77.3695H80.4903V78.2797C80.4903 79.5801 80.3602 80.4036 80.1002 80.7503C79.7534 81.0971 79.2333 81.2705 78.5398 81.2705C77.6729 81.2705 77.1528 81.0538 76.9794 80.6203C76.7193 80.2736 76.5893 79.4934 76.5893 78.2797V74.3787H85.0414V69.0474ZM53.3134 35.4989C53.9203 35.4989 54.4837 35.629 55.0039 35.889C55.3506 36.2358 55.524 36.6692 55.524 37.1894V49.8025C55.524 50.4961 55.3506 50.9728 55.0039 51.2329C54.6571 51.5797 54.0936 51.753 53.3134 51.753C52.6199 51.753 52.1431 51.5797 51.8831 51.2329C51.4496 50.9728 51.2329 50.4961 51.2329 49.8025V37.1894C51.2329 36.7559 51.4496 36.3225 51.8831 35.889C52.2298 35.629 52.7066 35.4989 53.3134 35.4989Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                </div>
              </Tooltip>

              {/* linkedin */}
              <Tooltip title="Linked-in" placement="bottom">
                <div className="ml-2 cursor-pointer">
                  <a
                    href="https://www.linkedin.com/company/lorry-care/"
                    target={"_black"}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 110 110"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M55.057 0.961769C62.5989 0.961769 69.6641 2.39213 76.2524 5.25285C82.8407 8.11357 88.6055 11.9929 93.5467 16.8908C98.488 21.7887 102.389 27.5318 105.25 34.1201C108.11 40.7085 109.541 47.7736 109.541 55.3155C109.541 62.8574 108.11 69.9225 105.25 76.5108C102.389 83.0991 98.488 88.8639 93.5467 93.8052C88.6055 98.7464 82.8407 102.647 76.2524 105.508C69.6641 108.369 62.5989 109.799 55.057 109.799C47.5151 109.799 40.45 108.369 33.8617 105.508C27.2734 102.647 21.5303 98.7464 16.6324 93.8052C11.7345 88.8639 7.85515 83.0991 4.99443 76.5108C2.13371 69.9225 0.703346 62.8574 0.703346 55.3155C0.703346 47.7736 2.13371 40.7085 4.99443 34.1201C7.85515 27.5318 11.7345 21.7887 16.6324 16.8908C21.5303 11.9929 27.2734 8.11357 33.8617 5.25285C40.45 2.39213 47.5151 0.961769 55.057 0.961769ZM38.1528 41.7921H24.4993V86.0032H38.1528V41.7921ZM31.261 38.2812C33.1682 38.2812 34.7936 37.631 36.1373 36.3307C37.4809 35.0304 38.1528 33.4266 38.1528 31.5195C38.1528 29.6123 37.4809 28.0086 36.1373 26.7083C34.7936 25.4079 33.1682 24.7578 31.261 24.7578C29.3539 24.7578 27.7502 25.4079 26.4498 26.7083C25.1495 28.0086 24.4993 29.6123 24.4993 31.5195C24.4993 33.4266 25.1495 35.0304 26.4498 36.3307C27.7502 37.631 29.3539 38.2812 31.261 38.2812ZM85.7448 60.3867C85.7448 57.266 84.8779 54.2102 83.1441 51.2194C81.4103 48.2287 79.1564 45.9531 76.3824 44.3927C73.8684 43.0057 70.9427 42.2688 67.6052 42.1822C64.2677 42.0955 61.2119 42.6589 58.4379 43.8726V41.7921H44.9145V86.0032H58.4379V58.9564L64.1593 56.2257C64.8528 55.8789 65.7847 55.7056 66.955 55.7056C68.1253 55.7056 69.0572 55.9223 69.7507 56.3557C70.2709 56.6158 70.791 57.1793 71.3111 58.0462C71.8313 58.913 72.0913 59.6932 72.0913 60.3867V86.0032H85.7448V60.3867Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                </div>
              </Tooltip>

              {/* twitter */}
              <Tooltip title="twitter" placement="bottom">
                <div className="ml-2 cursor-pointer">
                  <a href="https://twitter.com/lorry_care_" target="_blank">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 109 109"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M54.3537 0C61.8956 0 68.9607 1.43036 75.549 4.29108C82.1374 7.1518 87.9021 11.0311 92.8434 15.929C97.7846 20.8269 101.686 26.57 104.546 33.1584C107.407 39.7467 108.837 46.8118 108.837 54.3537C108.837 61.8956 107.407 68.9607 104.546 75.549C101.686 82.1374 97.7846 87.9021 92.8434 92.8434C87.9021 97.7846 82.1374 101.686 75.549 104.546C68.9607 107.407 61.8956 108.837 54.3537 108.837C46.8118 108.837 39.7467 107.407 33.1584 104.546C26.57 101.686 20.8269 97.7846 15.929 92.8434C11.0311 87.9021 7.1518 82.1374 4.29108 75.549C1.43036 68.9607 0 61.8956 0 54.3537C0 46.8118 1.43036 39.7467 4.29108 33.1584C7.1518 26.57 11.0311 20.8269 15.929 15.929C20.8269 11.0311 26.57 7.1518 33.1584 4.29108C39.7467 1.43036 46.8118 0 54.3537 0ZM81.4005 42.6507C83.9145 40.7436 86.125 38.4464 88.0322 35.759C86.8185 36.2791 85.5832 36.7126 84.3262 37.0593C83.0693 37.4061 81.7473 37.6662 80.3602 37.8395C81.7473 36.9726 82.9609 35.9107 84.0012 34.6537C85.0414 33.3967 85.7783 32.0314 86.2117 30.5577C84.9114 31.2512 83.5677 31.8797 82.1807 32.4432C80.7937 33.0066 79.3633 33.4184 77.8896 33.6785C76.676 32.4648 75.2456 31.4679 73.5985 30.6877C71.9515 29.9075 70.131 29.5174 68.1372 29.5174C66.3167 29.5174 64.6046 29.8642 63.0009 30.5577C61.3971 31.2512 60.0101 32.2048 58.8398 33.4184C57.6695 34.6321 56.7376 36.0407 56.0441 37.6445C55.3506 39.2482 55.0039 40.9603 55.0039 42.7808C55.0039 43.3009 55.0255 43.821 55.0689 44.3412C55.1122 44.8613 55.1772 45.3381 55.2639 45.7715C49.8025 45.5115 44.7313 44.1678 40.0501 41.7405C35.3689 39.3132 31.3812 36.0624 28.0871 31.9881C26.8734 33.9819 26.2666 36.1925 26.2666 38.6197C26.2666 40.8736 26.8084 42.9758 27.892 44.9263C28.9756 46.8768 30.3843 48.4589 32.1181 49.6725C29.8642 49.4991 27.8704 48.9357 26.1366 47.9821V48.1121C26.1366 51.4063 27.1552 54.2453 29.1924 56.6293C31.2295 59.0132 33.7652 60.5086 36.7993 61.1154C36.1925 61.2888 35.6073 61.4188 35.0438 61.5055C34.4804 61.5922 33.8952 61.6355 33.2884 61.6355C32.8549 61.6355 32.4432 61.6139 32.0531 61.5705C31.663 61.5272 31.2512 61.4622 30.8178 61.3755C31.6846 63.9761 33.2234 66.1433 35.4339 67.8771C37.6445 69.6109 40.2235 70.4778 43.1709 70.4778C40.917 72.2982 38.3813 73.7069 35.564 74.7038C32.7466 75.7007 29.8208 76.1992 26.7867 76.1992C26.1799 76.1992 25.6165 76.1775 25.0963 76.1342C24.5762 76.0908 24.0561 76.0258 23.5359 75.9391C26.4833 77.8463 29.6691 79.32 33.0933 80.3602C36.5175 81.4005 40.0934 81.9206 43.821 81.9206C49.8892 81.9206 55.2639 80.772 59.9451 78.4748C64.6263 76.1775 68.5489 73.2301 71.7131 69.6325C74.8772 66.035 77.2828 62.004 78.9299 57.5395C80.577 53.075 81.4005 48.6756 81.4005 44.3412V42.6507Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                </div>
              </Tooltip>
            </div>
          </div>
        </div>
      </footer>

      {/* subfooter START */}
      <div
        className="sub_header bg-white flex justify-center items-center"
        style={{ "height": "5vh" }}
      >
        <p className="text-black w-fit text-sm">
          &#169; Copyright Onewhistle Marketplace Private Limited. All rights
          reserved
        </p>
      </div>
      {/* subfooter END */}
    </>
  );
};

export default Footer;
